import { createApp } from 'vue'
import UnluUyumu from './UnluUyumu.vue'
import './assets/global.css'

createApp(UnluUyumu).mount('#unlu-uyumu')
